// extracted by mini-css-extract-plugin
module.exports = {"solar-calculator":"solar-panels_solar-calculator__vvMz8"};